import React, { useState } from "react";
import { NetworkMemberType } from "@buf/brevdev_devplane.bufbuild_es/devplaneapi/v1/network_pb";
import { EditNetworkModeDialog } from "components/Environment/List/Redesign/Compute/Cards/EditNetworkModeDialog";
import { networkModes } from "components/Environment/Networks/networkMode";
import { Button } from "components/Graphs/Button";
import { Badge } from "components/Graphs/Badge";

interface NetworkModeSummaryProps {
  name: string;
  memberType: NetworkMemberType | null;
  unavailable?: boolean;
  disabled?: boolean;
  onSetMode?: (memberType: NetworkMemberType) => Promise<void>;
}

export const NetworkModeSummary: React.FC<NetworkModeSummaryProps> = ({
  name,
  memberType,
  unavailable = false,
  disabled = false,
  onSetMode,
}) => {
  const [editOpen, setEditOpen] = useState(false);
  const mode = networkModes.find(({ type }) => type === memberType);

  if (unavailable) return <Badge variant="neutral">Unavailable</Badge>;

  return (
    <>
      <div className="flex w-full flex-col gap-4 rounded-md bg-secondaryBg p-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="min-w-0">
          {mode ? (
            <>
              <p className="text-sm font-medium text-primary">{mode.label}</p>
              <p className="mt-1 text-xs text-secondary">{mode.description}</p>
            </>
          ) : (
            <Badge variant="info">Pending</Badge>
          )}
        </div>
        {onSetMode && (
          <Button
            type="button"
            variant="primary"
            disabled={disabled}
            className="shrink-0 disabled:bg-highlight disabled:text-black"
            onClick={() => setEditOpen(true)}
          >
            Edit Network Mode
          </Button>
        )}
      </div>
      {onSetMode && (
        <EditNetworkModeDialog
          name={name}
          memberType={memberType}
          open={editOpen}
          onOpenChange={setEditOpen}
          onSetMode={onSetMode}
        />
      )}
    </>
  );
};
